
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as aboutjJTQ9g1ouglbx_457UA_xMqmvVSLrS9hASDKNJogwH9cIMeta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/about.vue?macro=true";
import { default as indexgokOEsFq9E4_45Ebk7ZUMLQtqS_459SUER74mwavQRupSeIMeta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/index.vue?macro=true";
import { default as loginT4ZrGjvki_SwIkTR_xTEuy_bCnOH13jR9gR0wMsDh4wMeta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/login.vue?macro=true";
import { default as _errorQ2NcvU8ZXpPmSZw8CHir2hGsgRkQ79JptG6qtWNOifUMeta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/_error.vue?macro=true";
import { default as lineupYT_6uSYSaqjeEReBFdBnToVCJAWsscDezQxAZ1ItENkMeta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/lineup.vue?macro=true";
import { default as logoutfZ6Nl0FIG7OoUepIIFozzOmzS1w_7BReVSi3hXnGUOkMeta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/logout.vue?macro=true";
import { default as signupCKPBXXnzKxchjsRteJ_yPmcIHfEBjHC5cukz3own2J4Meta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/signup.vue?macro=true";
import { default as supportDCOMLI_FiXomgk_EYK4ED_ICDY5YnRBDpxOqOZQEKI4Meta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/support.vue?macro=true";
import { default as settingsSoZI025QKDcnFns4G3ik85IAXg5FHQbvf6AreefXJtoMeta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/settings.vue?macro=true";
import { default as subkreweDx8iuCzO5GkK3jMbAv2GZ2tDDgT7x8a2sISa2__454u98Meta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/subkrewe.vue?macro=true";
import { default as tracking_4kd4mh8Bn43wybh1ADrhAu_sRewYHTymRsIl4j7vjQMeta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/tracking.vue?macro=true";
import { default as logo_45testtsQYW5ZQwboPkxoelchd8_gSjwamckFm3IjYFqLecA8Meta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/logo-test.vue?macro=true";
import { default as signup_45flow5fQnxEwzUC_45GQDWIMUkzPcmgyjeMJGo_31PL9nhnMIQMeta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/signup-flow.vue?macro=true";
import { default as emailsb4hRTGgCdNmZFhuqwRp3i565UOMpzUb7LCyNniRBEQIMeta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/admin/emails.vue?macro=true";
import { default as lineuphWMUe3bFBf1aDZ2T6yNPMYQ2u1tm81QmJwVvzXA_qBMMeta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/admin/lineup.vue?macro=true";
import { default as verify_45emailaysIGolBpVlmSbY2TkrxS9c_45D_45E5cWjwW7JFjjFMSS8Meta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/verify-email.vue?macro=true";
import { default as membersv02MfTj_45l11d1o1u_45bQD0krqasbSvnydEhIsd8OduywMeta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/admin/members.vue?macro=true";
import { default as index_45e35dr8mffK8QyjyzB71Gqj4AL4_aDb1zDW8eN3GH5kMeta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/checkin/index.vue?macro=true";
import { default as notificationsbHRzEnhM9qgkBaBvhDeWq0yrIESOamIulUiIp5opyDgMeta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/notifications.vue?macro=true";
import { default as captainsK5BFLV9Dbh7YpTYhCovTQ29y9xbdj1E9l8QjKZ6g_45OYMeta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/admin/captains.vue?macro=true";
import { default as qrcodeE8_KdnCPtc4Xz1oVIlzlJ9vH2SfADVkcmnVjRb1CpB0Meta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/checkin/qrcode.vue?macro=true";
import { default as privacy_45policyLRK8DY_45apyRRduf7CgxlgjlXiT9Beg5DpE6r4BbIhx8Meta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/privacy-policy.vue?macro=true";
import { default as inventoryhwHNF7DLMR_45eoWBL3H94RHjqwRlzpnF9POLhVKjld0kMeta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/admin/inventory.vue?macro=true";
import { default as subkrewes4NCdkzDaYFqVYHbx_45UkIKHkQfpWXzmnMLBzRbA07eq8Meta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/admin/subkrewes.vue?macro=true";
import { default as forgot_45password_kFWRP68r1Aa0rmeLDtcmBFJhOT5yoCQCyolgSSCRXcMeta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/forgot-password.vue?macro=true";
import { default as radio_45listOA_451b5MWV5L3BbC3o5lx_vbDi1qegIJfGO4WjhLsp_8Meta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/admin/radio-list.vue?macro=true";
import { default as terms_45of_45serviceic0IKkaAXbO_4531ki2FlTjUr5nPX2bZfe_45mJXvwM1N_45EMeta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/terms-of-service.vue?macro=true";
import { default as equipmentSSGjEhsfYy7UDV2l_e19_45yFR9MI1H0jx_45_45uAgjoSVa0Meta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/checkin/equipment.vue?macro=true";
import { default as register_45subkreweccz_45_dzEGzSlSMDaRpiNtDVPQd110seDxQ3RReE9fpwMeta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/register-subkrewe.vue?macro=true";
import { default as lineup_45status_onZExtztmgsN_4yPiQouUt9HFm1cXASw_4502ooYrEsUMeta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/admin/lineup-status.vue?macro=true";
import { default as checked_45inXaCdE0P1TOVgFlOYPhNMxVZJ27_9ebwCu2EzWZRjVuQMeta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/admin/reporting/checked-in.vue?macro=true";
import { default as lifetimersEm6vKWLgEyKO4H_45i0GUWRTXFNI6k5u1Hg0UxF57MtNoMeta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/admin/reporting/lifetimers.vue?macro=true";
import { default as vip_45passesy2Gb0fUVVN3HjLXcnBpkER0lg8aA5wx3kMU5_GXnUoEMeta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/admin/reporting/vip-passes.vue?macro=true";
export default [
  {
    name: "about",
    path: "/about",
    meta: aboutjJTQ9g1ouglbx_457UA_xMqmvVSLrS9hASDKNJogwH9cIMeta || {},
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginT4ZrGjvki_SwIkTR_xTEuy_bCnOH13jR9gR0wMsDh4wMeta || {},
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/login.vue")
  },
  {
    name: "_error",
    path: "/_error",
    meta: _errorQ2NcvU8ZXpPmSZw8CHir2hGsgRkQ79JptG6qtWNOifUMeta || {},
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/_error.vue")
  },
  {
    name: "lineup",
    path: "/lineup",
    meta: lineupYT_6uSYSaqjeEReBFdBnToVCJAWsscDezQxAZ1ItENkMeta || {},
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/lineup.vue")
  },
  {
    name: "logout",
    path: "/logout",
    meta: logoutfZ6Nl0FIG7OoUepIIFozzOmzS1w_7BReVSi3hXnGUOkMeta || {},
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/logout.vue")
  },
  {
    name: "signup",
    path: "/signup",
    meta: signupCKPBXXnzKxchjsRteJ_yPmcIHfEBjHC5cukz3own2J4Meta || {},
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/signup.vue")
  },
  {
    name: "support",
    path: "/support",
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/support.vue")
  },
  {
    name: "settings",
    path: "/settings",
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/settings.vue")
  },
  {
    name: "subkrewe",
    path: "/subkrewe",
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/subkrewe.vue")
  },
  {
    name: "tracking",
    path: "/tracking",
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/tracking.vue")
  },
  {
    name: "logo-test",
    path: "/logo-test",
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/logo-test.vue")
  },
  {
    name: "signup-flow",
    path: "/signup-flow",
    meta: signup_45flow5fQnxEwzUC_45GQDWIMUkzPcmgyjeMJGo_31PL9nhnMIQMeta || {},
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/signup-flow.vue")
  },
  {
    name: "admin-emails",
    path: "/admin/emails",
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/admin/emails.vue")
  },
  {
    name: "admin-lineup",
    path: "/admin/lineup",
    meta: lineuphWMUe3bFBf1aDZ2T6yNPMYQ2u1tm81QmJwVvzXA_qBMMeta || {},
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/admin/lineup.vue")
  },
  {
    name: "verify-email",
    path: "/verify-email",
    meta: verify_45emailaysIGolBpVlmSbY2TkrxS9c_45D_45E5cWjwW7JFjjFMSS8Meta || {},
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/verify-email.vue")
  },
  {
    name: "admin-members",
    path: "/admin/members",
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/admin/members.vue")
  },
  {
    name: "checkin",
    path: "/checkin",
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/checkin/index.vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/notifications.vue")
  },
  {
    name: "admin-captains",
    path: "/admin/captains",
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/admin/captains.vue")
  },
  {
    name: "checkin-qrcode",
    path: "/checkin/qrcode",
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/checkin/qrcode.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: privacy_45policyLRK8DY_45apyRRduf7CgxlgjlXiT9Beg5DpE6r4BbIhx8Meta || {},
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/privacy-policy.vue")
  },
  {
    name: "admin-inventory",
    path: "/admin/inventory",
    meta: inventoryhwHNF7DLMR_45eoWBL3H94RHjqwRlzpnF9POLhVKjld0kMeta || {},
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/admin/inventory.vue")
  },
  {
    name: "admin-subkrewes",
    path: "/admin/subkrewes",
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/admin/subkrewes.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgot_45password_kFWRP68r1Aa0rmeLDtcmBFJhOT5yoCQCyolgSSCRXcMeta || {},
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/forgot-password.vue")
  },
  {
    name: "admin-radio-list",
    path: "/admin/radio-list",
    meta: radio_45listOA_451b5MWV5L3BbC3o5lx_vbDi1qegIJfGO4WjhLsp_8Meta || {},
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/admin/radio-list.vue")
  },
  {
    name: "terms-of-service",
    path: "/terms-of-service",
    meta: terms_45of_45serviceic0IKkaAXbO_4531ki2FlTjUr5nPX2bZfe_45mJXvwM1N_45EMeta || {},
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/terms-of-service.vue")
  },
  {
    name: "checkin-equipment",
    path: "/checkin/equipment",
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/checkin/equipment.vue")
  },
  {
    name: "register-subkrewe",
    path: "/register-subkrewe",
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/register-subkrewe.vue")
  },
  {
    name: "admin-lineup-status",
    path: "/admin/lineup-status",
    meta: lineup_45status_onZExtztmgsN_4yPiQouUt9HFm1cXASw_4502ooYrEsUMeta || {},
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/admin/lineup-status.vue")
  },
  {
    name: "admin-reporting-checked-in",
    path: "/admin/reporting/checked-in",
    meta: checked_45inXaCdE0P1TOVgFlOYPhNMxVZJ27_9ebwCu2EzWZRjVuQMeta || {},
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/admin/reporting/checked-in.vue")
  },
  {
    name: "admin-reporting-lifetimers",
    path: "/admin/reporting/lifetimers",
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/admin/reporting/lifetimers.vue")
  },
  {
    name: "admin-reporting-vip-passes",
    path: "/admin/reporting/vip-passes",
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/admin/reporting/vip-passes.vue")
  }
]